import { createSelector } from 'reselect'

export const getArgN = (n) => (...args) => args[n]

export const memoize = (fn) => createSelector([ getArgN(0), getArgN(1), getArgN(2), getArgN(3) ], fn)
export const getKey = memoize((arr, key) => arr.map(item => item[key]))

/**
 * Filter array on key by value
 * e.g. filter list of users to those with type === 'admin'
 * filter(users, 'type', 'admin')
 */

export const filter = memoize(function filter (arr, key, value) {
  if (value == null) return arr.slice()
  return arr.filter(item => item[key] === value)
})

// ----
// Utilities
// ----

/**
 * Remove duplicates from array
 */

export function unique (arr) {
  return Array.from(new Set(arr))
}

export function makeAPI (selfExports, dependencies) {
  const stateStore = {}
  return createSelector([
    state => Object.assign(stateStore, { state }),
    ...dependencies
  ], () => {
    return Object.keys(selfExports).reduce((api, key) => Object.assign(api, {
      [key]: (
        typeof selfExports[key] === 'function'
          ? (...args) => selfExports[key](stateStore.state, ...args)
          : selfExports[key]
      )
    }), {})
  })
}



// WEBPACK FOOTER //
// ../webmango-core/selectors/utils.js